import { createStore } from 'vuex';
const requestHelper = require('../../../ClarityPayAdminV2/src/helpers/requestHelper');

export default createStore({
	state: {
		login: localStorage.getItem('login'), // Get authentication token from local storage
		sessionTimeout: 7 * 60 * 1000, // 5 minutes in milliseconds
		lastActiveTime: Date.now(),

		merchant: null,
		pos: null,
		pg: null,
		pgData: null,
		permissions: null,
		roleDetails: [],
		customerDetails: null,
		userPermissionArray: [],
		alertMessage: '',
    	isAlertVisible: false,
    	alertType: 'success',
		businessAttributes: [],
		merchantGateway: [],
		routingTemplate: [],
		routingRule: []
	},
	mutations: {
		updateLastActiveTime(state) {
			state.lastActiveTime = Date.now();
		},

		setMerchant(state, merchant) {
			state.merchant = merchant;
		},

		setPOS(state, pos) {
			state.pos = pos;
		},

		setGateways(state, pg) {
			state.pg = pg;
		},

		setCredentials(state, pgData) {
			state.pgData = pgData;
		},

		setPermissions(state, permissions) {
			state.permissions = permissions;
		},

		setRole(state, role) {
			state.roleDetails = role;
		},

		setCustomer(state, customerDetails) {
			state.customerDetails = customerDetails;
		},
		setAlert(state, payload) {
			console.log('store', payload)
			state.alertMessage = payload.message;
			state.isAlertVisible = payload.isVisible;
			state.alertType = payload.alertType;
		},
		clearAlert(state) {
			state.alertMessage = '';
			state.isAlertVisible = false;
		},
		updateBusinessAttributes(state, data) {
			state.businessAttributes = data;
		},
		setUserPermissionArray(state, data) {
			state.userPermissionArray = data;
		},
		updateMerchantGateway(state, data) {
			state.merchantGateway = data;
		},
		updateRoutingTemplate(state, data) {
			state.routingTemplate = data;
		},
		updateRoutingRules(state, data) {
			state.routingRule = data;
		}
	},
	getters: {
		getRoles(state) {
			return state.roleDetails
		},
		userPermissions() {
			return state.permissions;
		},
		businessAttributes() {
			return state.businessAttributes;
		},
		merchantGateway() {
			return state.merchantGateway;
		}
	},
	actions: {
		checkSession({ state }) {
			if (localStorage.getItem('login') && state.lastActiveTime) {
				const currentTime = Date.now();
				const elapsedTime = currentTime - state.lastActiveTime;
				if (elapsedTime >= state.sessionTimeout) {
					localStorage.removeItem('login');
					return false;
				}
				else
					return true;
			}
		},
		updateLastActiveTime({ commit }) {
			commit('updateLastActiveTime');
		},
		async fetchPermissions({ commit }) {
			let roleId = await requestHelper.request(`/getUserRoleId`, null, 'get');
			roleId = roleId.data.data.userRoleId;

			const userPermissions = await requestHelper.request(`/getUserRolePermission/${roleId}`, null, 'get');
			const permissions = userPermissions.data.data;
			commit('setUserPermissionArray', permissions);
			console.log('userPermissions - store', userPermissions.data.data);
			const permissionsObj = {};

			for (const module in permissions) {
				const { moduleName, permissionList } = permissions[module];
				permissionList.forEach(permission => {
					const lowerCasePermissionName = permission.name.toLowerCase();
					if (!permissionsObj[lowerCasePermissionName]) {
						permissionsObj[lowerCasePermissionName] = [];
					}
					if (!permissionsObj[lowerCasePermissionName].includes(moduleName)) {
						permissionsObj[lowerCasePermissionName].push(moduleName);
					}
				});
			}

			let permissionsArray = [];

			for (const [action, entities] of Object.entries(permissionsObj)) {
				entities.forEach(entity => {
					permissionsArray.push(`${action}${entity}`);
				});
			}
			commit('setPermissions', permissionsArray);
		},
		alertMessages({ commit }, data) {
			commit('setAlert', { message: data.message, isVisible: true, alertType: data?.alert || 'success' });
			setTimeout(() => {
			  	commit('clearAlert');
			}, 2000);
		}
	}
});
